// @ts-check
import { uploadInformApi } from "../api/informs";
import StudyForList from "../models/studies/list";
/**
 * @param {File} inform
 * @param {StudyForList} StudyForList
 * @returns {Promise<boolean>}
 */
export async function uploadInform(inform, StudyForList) {
  const fecha = new Date().toISOString();
  const dataParaServidor = {
    ID: StudyForList.id || StudyForList.id, // Mapea a 'ID'
    EST_UID: StudyForList.uuid || StudyForList.uuid, // Mapea a 'EST_UID'
    NOMBRE: StudyForList.patientName || StudyForList.patientName, // Mapea a 'NOMBRE'
    fechasubida: fecha, // Ya funciona correctamente
  };
  const fd = new FormData();
  fd.append("files", inform);
  fd.append("inform", JSON.stringify(dataParaServidor));
  const res = await uploadInformApi(fd);
  if (res.estado !== true) {
    throw new Error("Error al subir el informe");
  }
  return true;
}
